import * as go from 'gojs';
import { getImagePlateFeeder } from 'unitData/Feeders/Plate/getImagePlateFeeder';
import { getImageBinding, getIOPort, makeNode } from '../../utils';

const PlateFeederTemplate = makeNode(
  getImageBinding('modelName', getImagePlateFeeder),
  [getIOPort(go.Spot.Top, 'input'), getIOPort(go.Spot.Right, 'output')],
);

export default PlateFeederTemplate;
